import dayjs from 'dayjs'
import doneCreate from '../../../assets/images/done-create.svg'
import errorAlert from '../../../assets/images/error-alert.svg'
import { DocumentDetailModel } from '../../../models/documentDetail'
import { getPaymentDetailAmount, getPaymentDetailValue } from '../helper'
import NumberFormat from 'react-number-format'
import { WatDatePicker } from '../../../component/datePicker'
import { ChangeEvent } from 'react'
import { IPaymentDetailProps } from './ipaymentDetailProps.interface'
import { Bank } from '../../../component/entryForm/bank'
import { PayInBank } from '../../../component/entryForm/bankAccount'
import { PAYMENTMODE } from '../../../constants'

export const CreditCard: React.VFC<IPaymentDetailProps> = ({
  paymentDetail,
  handleEnterKey,
  formErrors,
  paymentMethod,
  onChangeAmountDetail,
  handleWatDatePickerChangeAmountDetail,
  handlePayInDateChangeAmountDetail,
  branchCode
}) => {
  return (
    <div className="required">
      <span className="amount-text">ชื่อเจ้าของบัตรเครดิต</span>
      <input
        onKeyPress={(e: any) => handleEnterKey(e)}
        className={`amount-input ${formErrors.creditCard_HolderName && 'error-border-validate'}`}
        type="text"
        name="creditCard_HolderName"
        autoComplete="off"
        onChange={e => onChangeAmountDetail(e, paymentMethod.name)}
        value={getPaymentDetailValue(paymentDetail, paymentMethod.name, 'creditCard_HolderName')}
        maxLength={30}
      />
      {formErrors.creditCard_HolderName && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณากรอกข้อมูล
        </div>
      )}

      <span className="amount-text">เจ้าของบัตรเครดิตมีความสัมพันธ์เป็นอะไรกับผู้เอาประกันภัย</span>
      {/* <input
            onKeyPress={(e: any) => handleEnterKey(e)}
            className={`amount-input ${
              formErrors.creditCard_HolderName && 'error-border-validate'
            }`}
            type="text"
            name="creditCard_HolderRelationship"
            autoComplete="off"
            onChange={e => onChangeAmountDetail(e, paymentMethod.name)}
            value={getPaymentDetailValue(
              paymentDetail,
              paymentMethod.name,
              'creditCard_HolderRelationship'
            )}
          /> */}
      <select
        className={`select-input ${
          formErrors.creditCard_HolderRelationship && 'error-border-validate'
        }`}
        name="creditCard_HolderRelationship"
        placeholder="เจ้าของบัตรเครดิตมีความสัมพันธ์เป็นอะไรกับผู้เอาประกันภัย"
        onChange={e => onChangeAmountDetail(e, paymentMethod.name)}
        value={getPaymentDetailValue(
          paymentDetail,
          paymentMethod.name,
          'creditCard_HolderRelationship'
        )}
      >
        <option value="027">ตนเอง </option>
        <option value="001">บิดา </option>
        <option value="002">มารดา </option>
        <option value="003">คู่สมรส </option>
        <option value="004">บุตร </option>
        <option value="009">บุตรบุญธรรมตามกฎหมาย </option>
        <option value="020">บิดาบุญธรรม </option>
        <option value="021">มารดาบุญธรรม</option>
        <option value="005">ปู่ </option>
        <option value="006">ย่า </option>
        <option value="007">ตา </option>
        <option value="008">ยาย </option>
        <option value="022">พี่ร่วมบิดาและมารดาเดียวกัน </option>
        <option value="023">น้องร่วมบิดาและมารดาเดียวกัน</option>
        <option value="024">พี่ร่วมบิดาหรือมารดาเดียวกัน </option>
        <option value="025">น้องร่วมบิดาหรือมารดาเดียวกัน</option>
        <option value="017">พี่ </option>
        <option value="018">น้อง </option>
        <option value="014">หลาน</option>
        <option value="010">ลุง </option>
        <option value="011">ป้า </option>
        <option value="012">น้า </option>
        <option value="013">อา </option>
        <option value="026">บริษัท</option>
        <option value="028">กองมรดก </option>
        <option value="029">คู่ชีวิต</option>
        <option value="030">ลูกพี่ลูกน้อง</option>
        {/* <option value="019">อื่นๆ โปรดระบุ...</option> */}
      </select>
      {formErrors.creditCard_HolderName && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณากรอกข้อมูล
        </div>
      )}

      <span className="amount-text">ประเภทบัตร</span>
      <select
        className={`select-input ${formErrors.creditCard_Type && 'error-border-validate'}`}
        name="creditCard_Type"
        placeholder="ประเภทบัตร"
        onChange={e => onChangeAmountDetail(e, paymentMethod.name)}
        value={getPaymentDetailValue(paymentDetail, paymentMethod.name, 'creditCard_Type')}
      >
        <option value="">เลือก</option>
        {/* <option value="BPT">BPT</option> */}
        {/* <option value="EDC">EDC</option> */}
        {/* <option value="KPT">KPT</option> */}
        <option value="MAS">Master</option>
        {/* <option value="SPT">SPT</option> */}
        <option value="JCB">JCB</option>
        <option value="VSA">VISA</option>
      </select>
      {formErrors.creditCard_Type && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณาเลือกประเภทบัตร
        </div>
      )}

      <span className="amount-text">เลขที่บัตร</span>
      <NumberFormat
        onKeyPress={(e: any) => handleEnterKey(e)}
        className={`amount-input ${formErrors.creditCard_Number && 'error-border-validate'}`}
        type="text"
        name="creditCard_Number"
        format="#### #### #### ####"
        autoComplete="off"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeAmountDetail(e, paymentMethod.name)}
        value={getPaymentDetailValue(paymentDetail, paymentMethod.name, 'creditCard_Number')}
      />
      {formErrors.creditCard_Number && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณากรอกข้อมูล
        </div>
      )}

      <span className="amount-text">วันที่หมดอายุ</span>
      <NumberFormat
        onKeyPress={(e: any) => handleEnterKey(e)}
        className={`amount-input ${formErrors.creditCard_ExpDate && 'error-border-validate'}`}
        type="text"
        name="creditCard_ExpDate"
        format="##/##"
        placeholder="MM/YY"
        autoComplete="off"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeAmountDetail(e, paymentMethod.name)}
        value={getPaymentDetailValue(paymentDetail, paymentMethod.name, 'creditCard_ExpDate')}
      />
      {formErrors.creditCard_ExpDate && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          {formErrors.creditCard_ExpDate}
        </div>
      )}

      <span className="amount-text">จำนวนเงิน(บาท)</span>
      <NumberFormat
        onKeyPress={(e: any) => handleEnterKey(e)}
        allowNegative={false}
        thousandSeparator={true}
        prefix=""
        name="paymentAmount"
        className={`amount-input ${formErrors.paymentAmountCard && 'error-border-validate'}`}
        inputMode="decimal"
        decimalScale={2}
        autoComplete="off"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onChangeAmountDetail(e, paymentMethod.name)}
        value={getPaymentDetailAmount(paymentDetail, paymentMethod.name)}
      />
      {formErrors.paymentAmountCard && (
        <div className="error-text-validate">
          <img src={errorAlert} alt="ErrorAlert" />
          กรุณากรอกข้อมูล
        </div>
      )}
    </div>
  )
}
